import Page, { PageTab } from "../../shared/components/Page";
import CoServicePlanImportsTab from "./CoServicePlanImportsTab";
import ServicePlansDashboardPage from "./ServicePlansDashboardPage";

const tabs: PageTab[] = [
  {
    header: "Imports",
    route: "app.patients.servicePlans.imports",
    component: <CoServicePlanImportsTab />,
  },
  {
    header: "Service Plans",
    route: "app.patients.servicePlans.plans",
    component: <ServicePlansDashboardPage />,
  },
];

export default function ServicePlansDashboardRoute() {
  return <Page.Tabbed tabs={tabs} />;
}
